import { render, staticRenderFns } from "./PatientMobile.vue?vue&type=template&id=2b5aaf38"
import script from "./PatientMobile.vue?vue&type=script&lang=js"
export * from "./PatientMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports